"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstrateNotCompatibleRule = void 0;
var HIDDEN_CLASS = 'is-hidden';
var SubstrateNotCompatibleRule = /** @class */ (function () {
    function SubstrateNotCompatibleRule() {
    }
    SubstrateNotCompatibleRule.prototype.apply = function (el, type) {
        type === this.optionNoneSelected ? this.enableSubstrates(el) : this.disableSubstrates(el);
    };
    SubstrateNotCompatibleRule.prototype.disableSubstrates = function (el) {
        var substratesToHide = this.querySubstrates(el);
        var needsFallbackToDefault = false;
        for (var i = 0; i < substratesToHide.length; i++) {
            substratesToHide[i].classList.add(this.disabledClass);
            this.toggleMessage(el, true);
            if (substratesToHide[i].classList.contains('selected')) {
                needsFallbackToDefault = true;
            }
        }
        if (needsFallbackToDefault) {
            this.selectDefaultSubstrate(el);
        }
    };
    SubstrateNotCompatibleRule.prototype.enableSubstrates = function (el) {
        var substratesToShow = this.querySubstrates(el);
        for (var i = 0; i < substratesToShow.length; i++) {
            substratesToShow[i].classList.remove(this.disabledClass);
            this.toggleMessage(el, false);
        }
    };
    SubstrateNotCompatibleRule.prototype.querySubstrates = function (el) {
        return el.querySelectorAll(this.incompatibleSubstrates.join(', '));
    };
    SubstrateNotCompatibleRule.prototype.selectSubstrate = function (defaultSubstrate) {
        setTimeout(function () { return defaultSubstrate.click(); }, 0);
    };
    SubstrateNotCompatibleRule.prototype.toggleMessage = function (el, showMessage) {
        var messages = el.querySelectorAll(this.messageSelector);
        messages.forEach(function (message) {
            if (message) {
                if (showMessage) {
                    message.classList.remove(HIDDEN_CLASS);
                }
                else {
                    message.classList.add(HIDDEN_CLASS);
                }
            }
        });
    };
    SubstrateNotCompatibleRule.prototype.selectDefaultSubstrate = function (el) {
        var defaultSubstrate = el.querySelector(this.firstFallbackSubstrate);
        if (defaultSubstrate) {
            this.selectSubstrate(defaultSubstrate);
            return;
        }
        if (this.secondFallbackSubstrate !== '') {
            // If P01 is not available for the product, P08 should be
            var backupDefaultSubstrate = el.querySelector(this.secondFallbackSubstrate);
            if (backupDefaultSubstrate) {
                this.selectSubstrate(backupDefaultSubstrate);
            }
        }
    };
    return SubstrateNotCompatibleRule;
}());
exports.SubstrateNotCompatibleRule = SubstrateNotCompatibleRule;
